<template>
  <div class="page-content"></div>
</template>

<script type="text/javascript">
import axios from "axios";
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      form: {
        month: "",
        year: "",
      },
      counts: {},
      salePerformancesData: [["Value (in ₹)", "Month"]],
      salePerformancesOptions: {
        title: "Sales Performance",
        subtitle: "Monthwise",
      },
      topSkusData: [["Value (in ₹)", "Sku"]],
      topSkusOptions: {
        title: "Top Skus",
        subtitle: "Monthwise",
      },
      topOutletsData: [["Value (in ₹)", "Outlet"]],
      topOutletsOptions: {
        title: "Top Outlets",
        subtitle: "Monthwise",
      },
      months: [],
      years: [],
      salePerformances: [],
      topPerformers: [],
      topSkus: [],
      topOutlets: [],
    };
  },
  mounted() {
    this.form.month = moment().format("M");
    this.form.year = moment().format("Y");
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get(
        `graphs/masters?month=${this.form.month}&year=${this.form.year}`
      );
      masters = masters.data;
      this.months = [];
      masters.months.forEach((month) => {
        this.months.push({
          id: month.value,
          name: month.text,
        });
      });
      this.years = [];
      masters.years.forEach((year) => {
        this.years.push({
          id: year,
          name: year,
        });
      });
      this.counts = masters.counts;
      this.salePerformances = masters.salePerformances;
      this.topPerformers = masters.topPerformers;
      this.topSkus = masters.topSkus;
      this.topOutlets = masters.topOutlets;
      this.updateSalePerformacesData();
      this.updateTopSkus();
      this.updateTopOutlets();
    },
    updateSalePerformacesData() {
      this.salePerformancesData = [["Value (in ₹)", "Month"]];
      this.salePerformances.forEach((sp) => {
        let data = [];
        data.push(sp.month);
        data.push(sp.value);
        this.salePerformancesData.push(data);
      });
    },
    updateTopSkus() {
      this.topSkusData = [["Value (in ₹)", "Sku"]];
      this.topSkus.forEach((ts) => {
        let data = [];
        data.push(ts.name);
        data.push(ts.value);
        this.topSkusData.push(data);
      });
    },
    updateTopOutlets() {
      this.topOutletsData = [["Value (in ₹)", "Outlet"]];
      this.topOutlets.forEach((to) => {
        let data = [];
        data.push(to.name);
        data.push(to.value);
        this.topOutletsData.push(data);
      });
    },
    search() {
      this.getMasters();
    },
  },
};
</script>
